import React from 'react';

import { Box, Button, Typography } from '@material-ui/core';
import { useAuth, useMounted } from 'hooks';
import getConfig from 'next/config';
import { useLeaderboard } from 'queries';
import { FormattedMessage, useIntl } from 'react-intl';

import Link from 'components/@navigation/Link';

import LeaderboardLoading from './LeaderboardLoading';
import LeaderboardSection from './LeaderboardSection';

const { publicRuntimeConfig: config } = getConfig();
interface Props {
  gameId: string;
  gameName: string;
}

const Leaderboard = ({ gameId, gameName }: Props) => {
  const isMounted = useMounted();
  const { isLoggedIn, user } = useAuth();
  const intl = useIntl();
  const { leaderboards, isLoading } = useLeaderboard(gameId);

  if (isLoading || !isMounted || !isLoggedIn || !user) {
    if (isMounted && !isLoggedIn && !isLoading) {
      return (
        <Box mx={4} mt={4} textAlign="center">
          <Typography variant="h4" component="div">
            <span role="img" aria-label="trophy">
              &#127942;
            </span>
            <Box my={2}>
              <Typography variant="h6" component="p" color="textPrimary">
                <FormattedMessage id="game.details.leaderboard.login.title" />
              </Typography>
            </Box>
            <Typography variant="body1" color="textSecondary">
              <FormattedMessage id="game.details.leaderboard.login.body" />
            </Typography>
            <Box mt={4}>
              <Button
                component={Link}
                href={config.DIGI_LOGIN_URL}
                variant="contained"
                color="primary"
              >
                <FormattedMessage id="game.details.leaderboard.login.button" />
              </Button>
            </Box>
          </Typography>
        </Box>
      );
    }
    return <LeaderboardLoading />;
  }

  let friends = leaderboards?.friendsLeaderboard ?? [];
  const overall = leaderboards?.totalLeaderboard ?? [];
  const totalPlayers = leaderboards?.totalPlayers ?? 0;

  return (
    <>
      {friends.length > 0 && (
        <Box mb={6}>
          <LeaderboardSection
            title={intl.formatMessage({ id: 'game.details.leaderboard.friends.title' })}
            body={intl.formatMessage({ id: 'game.details.leaderboard.friends.body' })}
            players={friends}
            currentUser={user.id}
          />
        </Box>
      )}
      {overall.length > 0 && (
        <LeaderboardSection
          title={intl.formatMessage({ id: 'game.details.leaderboard.overall.title' })}
          body={intl.formatMessage(
            {
              id: 'game.details.leaderboard.overall.body',
            },
            { game: gameName, total: totalPlayers },
          )}
          players={overall}
          currentUser={user.id}
        />
      )}
    </>
  );
};

export default Leaderboard;
